import { FileInput, type FormFile } from "../../form-fields/components/file-input/file-input";
import { Stack } from "../../stack";
import { Text } from "../../typography";
import { useFieldContext } from "../form/form-context";
import { FieldInfo } from "./fieldinfo";

type StateType<T extends boolean> = T extends true ? FormFile[] | undefined : FormFile | undefined;

type FileFieldProps = {
	heading?: string;
	label: string;
	helperText?: string;
	multiSelect?: boolean;
	exchangeForBlob?: (file: FormFile) => Promise<Blob>;
	acceptedFileTypes?: string[];
};

export const FileField = ({
	label,
	heading,
	helperText,
	multiSelect = false,
	exchangeForBlob,
	acceptedFileTypes,
}: FileFieldProps) => {
	const field = useFieldContext<StateType<typeof multiSelect>>();

	return (
		<Stack gap={2}>
			<legend className="flex flex-col gap-2">
				<Text bold className="text-headline">
					{heading}
				</Text>
				<Text bold={!heading}>{label}</Text>
			</legend>

			<FileInput
				value={
					field.state.value
						? Array.isArray(field.state.value)
							? field.state.value
							: [field.state.value]
						: []
				}
				allowsMultiple={multiSelect}
				exchangeForBlob={exchangeForBlob}
				onFileDeleted={() => field.handleChange([])}
				onSelect={(f) => field.handleChange(multiSelect ? f : f[0])}
				acceptedFileTypes={acceptedFileTypes}
			/>
			<FieldInfo field={field} helperText={helperText} />
		</Stack>
	);
};
